"use strict";

import PageCommon from "../PageCommon";
import Pqp from "../../3x1010/Pqp";

export default class Track extends PageCommon {
    constructor(props) {
        super();
        this.data = {
            ID: props.ID,
            Name: props.Name,
            MP3: {
                Length: props.MP3.Length,
                LengthFMT: props.MP3.LengthFMT,
                Url: props.MP3.Url,
            },
            isNew: props.isNew,
            Artists: props.Artists,
            Wave: props.Wave,
        };
        this.artistsConverted = false;
    }

    set(object) {
        this.data = Object.keys(this.data).map((field) => (this.data[field] = object[field]));
    }

    get() {
        return this.data;
    }

    setupArtistsObject(artists) {
        if (!this.artistsConverted) {
            this.data.Artists = this.data.Artists.map((id) => artists.data.filter((item) => item.get().ID === id)[0]);
            this.artistsConverted = true;
        }
    }

    renderListItem(userManager, artists, playlists) {
        const modelId = "#model-tracks-list";
        const item = document.querySelector(`${modelId} .track-item`).cloneNode(true);
        item.dataset.id = this.data.ID;
        let badge = "";
        if (this.data.isNew) {
            badge = item.querySelector(".tl-track .badge").cloneNode(true);
        }
        item.querySelector(".tl-track").innerHTML = this.data.Name;
        if (badge !== "") {
            item.querySelector(".tl-track").appendChild(badge);
        }

        this.setupArtistsObject(artists);

        // 240212 - PF - Multi Artist Link in Track List
        if (this.data.Artists.length > 0) {
            if (this.data.Artists[0] && !Pqp.isMobile()) {
                item.querySelector(".tl-artist").href = "javascript:void(0)";
                /*
                item.querySelector(".tl-artist").href = this.setUrlParams("/artist/" + this._normalizza_track_prop(this.data.Artists[0].data.Name), [
                    { key: "id", value: this.data.Artists[0].data.ID },
                    { key: "format", value: this._normalizza_track_prop(this.data.Artists[0].data.Format) },
                ]);
                //*/
            } else {
                item.querySelector(".tl-artist").href = "javascript:void(0)";
            }
            item.querySelector(".tl-artist").innerHTML = this.data.Artists.map((artist) => {
                if (artist) {
                    // return artist.get().Name;
                    var aid = artist.get().ID;
                    var af = artist.get().Format;
                    return "<a href=\"/artist/cimins?id=" + aid + "&format=" + af + "\" class=\"tl-artist changed\" data-page=\"artist\" data-id=\"" + aid + "\" data-format=\"" + af + "\">" + artist.get().Name + "</a>";
                }
                return "";
            }).join(", ");
        }
        item.querySelector(".tl-length").textContent = this.data.MP3.LengthFMT;

        const _this = this;

        item.querySelector(".play-btn").addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            const target = event.target.closest(".track-item");
            const id = target.dataset.id;
            _this.emitEvent("track_clicked", { detail: { id, target, source: "list" } });
            gtag("event", this.data.Name + " - {" + this.data.ID + "}", { event_category: "play", event_label: "Played Tracks" });
        });
        item.addEventListener("click", (event) => {
            if (event.target.tagName !== "I" && event.target.tagName !== "A") {
                const target = event.target.closest(".track-item");
                const id = target.dataset.id;
                this.emitEvent("track_clicked", { detail: { id, target } });
                gtag("event", this.data.Name + " - {" + this.data.ID + "}", { event_category: "play", event_label: "Played Tracks" });
            }
        });

        item.querySelector(".dropdown .dropdown-menu .dropdown-playlist").classList.remove("show");
        item.querySelector(".dropdown .icon-plus").addEventListener("click", (event) => {
            item.querySelector(".dropdown .dropdown-menu .dropdown-playlist").classList.remove("show");
        });

        /*
        item.querySelector(".dropdown .dropdown-menu .add-to-playlist").addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            item.querySelector(".dropdown .dropdown-menu .dropdown-playlist").classList.toggle("show");
        });
        */

        // PQP: Ho rimosso la gestione dell'over dal css perch� faceva casino e quindi l'ho dovuto gestire a mano
        let menuItem = jQuery(item.querySelector(".dropdown .dropdown-menu .add-to-playlist"));
        let menuItemToShow = jQuery(item.querySelector(".dropdown .dropdown-menu .dropdown-playlist")).show();
        this.menuItemToShowStatus = false;
        menuItemToShow.on("mouseenter", () => {
            this.menuItemToShowStatus = true;
        });
        menuItemToShow.on("mouseleave", () => {
            this.menuItemToShowStatus = false;
            menuItemToShow.hide();
        });
        if (Pqp.isMobile()) {
            menuItem.on("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (menuItemToShow.is(":visible")) {
                    menuItemToShow.hide();
                } else {
                    menuItemToShow.show();
                }
            });
        } else {
            menuItem.on("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
            });
        }
        if (!Pqp.isMobile()) {
            menuItem.on("mouseenter", () => {
                menuItemToShow.show();
            });
            menuItem.on("mouseleave", () => {
                requestAnimationFrame(() => {
                    if (!this.menuItemToShowStatus) {
                        menuItemToShow.hide();
                    }
                });
            });
        }

        item.querySelector(".dropdown .dropdown-submenu .create-link").addEventListener("click", (event) => {
            event.preventDefault();
            if (userManager.userLogged) {
                jQuery("#playlistModal").modal("show");
                document.querySelector("#playlistModal input[name=plTrackId]").value = _this.data.ID;
            } else {
                jQuery("#notLoggedModal").modal("show");
            }
        });

        let list = item.querySelector(".dropdown .dropdown-myplaylists");
        if (userManager.userPlaylists.length > 0) {
            const userPlaylists = playlists.getAddTrackMyPlaylistList(userManager);
            userPlaylists.map((playlist) => {
                const item = playlist.cloneNode(true);
                const button = item.querySelector("a");
                button.addEventListener("click", (event) => {
                    event.preventDefault();
                    playlists.addTrackToPlaylist(event.currentTarget.dataset.id, _this.data);
                });
                list.appendChild(item);
            });
            const found = userManager.userPlaylists.filter((playlist) => playlist.Tracks.indexOf(this.data.ID) > -1);
            if (found.length === 0) {
                item.querySelectorAll(".remove-playlist").forEach((el) => (el.style.display = "none"));
            } else {
                item.querySelector(".remove-playlist .remove-link").addEventListener("click", (event) => {
                    playlists.showRemoveTrackDialog(_this.data.ID, found[0]);
                });
            }
        } else {
            item.querySelectorAll(".remove-playlist").forEach((el) => (el.style.display = "none"));
        }

        item.querySelector(".dropdown .dropdown-menu .licenses-add").addEventListener("click", (event) => {
            event.preventDefault();
            _this.emitEvent("add_track_to_licenses", { detail: { track: _this.data } });
        });

        item.querySelector(".dropdown .dropdown-menu .download").addEventListener("click", (event) => {
            event.preventDefault();
            if (userManager.userLogged) {
                _this.requestDownload(userManager, this.data);
            } else {
                // jQuery("#notLoggedModal").modal("show");
                window.location.href = "/pricing";
            }
        });

        item.querySelector(".dropdown .dropdown-menu .match-video").addEventListener("click", (event) => {
            event.preventDefault();
            if (Pqp.isMobile()) {
                window.location.href = "/match-video-mobile";
            } else {
                _this.emitEvent("match_video_to_track", { detail: { track: _this.data } });
            }
        });

        return item;
    }

    dispose() {
        this.data = {};
    }
}
